import { combineReducers, configureStore } from "@reduxjs/toolkit";
import commonReducer from "../store/slices/common.slice";
import vscDashboardReducer from "../modules/vscDashboard/store/dashboard.slice";
import { Auth } from "../auth/auth";
import { deleteFilesFromGcs } from "../modules/vscDashboard/dashboard.service";
import tableInfoReducer from "./slices/table.slice";
import { ROUTES } from "../common/constants";
import userInfoReducer from "./slices/userInfo.slice";
import adminReducer from "../modules/Admin/store/admin.slice";
import workspaceReducer from "./slices/workspace.slice";
import agenticChatBotReducer from "../modules/AgenticChatbot/store/AgenticChatBot.slice";
import askOrionReducer from "./slices/askOrion.slice";
export const ROOT_REDUCER_ACTIONS = {
  LOGOUT: "LOGOUT",
};

const combinedReducer = combineReducers({
  commonReducer: commonReducer,
  vscDashboardReducer: vscDashboardReducer,
  tableInfoReducer: tableInfoReducer,
  userInfoReducer: userInfoReducer,
  adminReducer: adminReducer,
  workspaceReducer: workspaceReducer,
  agenticChatBotReducer: agenticChatBotReducer,
  askOrionReducer: askOrionReducer,
});

const rootReducer = (state: any, action: any) => {
  switch (action.type) {
    case ROOT_REDUCER_ACTIONS.LOGOUT:
      var processedFiles =
        state?.vscDashboardReducer?.vmoBot?.fileUpload?.processedFiles;
      if (Array.isArray(processedFiles) && processedFiles?.length > 0) {
        deleteFilesFromGcs({
          file_names: processedFiles,
          feature: "talk_to_contract",
        });
      }
      const auth = Auth.getInstance();
      auth.discardSession();
      window.location.replace(ROUTES.login);
      state = {};
      break;
    default:
      break;
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: {
    rootReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
